module.exports = "- Basic HTML shell\n\n-- head\n-- body\n\n-----------------------------------\n=> DIV with the ID 'root'\n"


//////////////////
// WEBPACK FOOTER
// ./src/slides/04_hello_world/notes_2.md
// module id = 1473
// module chunks = 0